import usePost from '../api/usePost';
import { useState } from 'react';

const INTERNAL_STATUS = {
  a_saisir: "A Saisir",
  en_commande: "En Commande",
  a_envoyer: "A Envoyer",
  incomplete: "Incomplete",
  sent: "Envoyé",
  unavailable: "Indisponible",
  pending_cancelation: "Annulation Demandée",
  canceled: "Annulation Validée",
  direct: "Envoi Direct",
  direct_to_customer_to_send: "A Imprimer"
};



const OrderLine = ({
    id,
    is_multi,
    order_date,
    product_name,
    ean,
    supplier,
    price,
    quantity,
    status,
    is_external,
    is_stock,
    notify,
    refresh,
    setRefresh,
    openOrderUpdateForm,
    openCommentForm,
    onUpdateClick ,
    comment,
    latest_date,
    global_order_id,
    destination_country,
    showButtons = true
}) => {
  const { postData, error } = usePost();
  const [direct_shipping_in_process, setDirectShippingInProcess] = useState(false);

  const updateStatus = async (status) => {
    if (status === 'unavailable') {
      const confirmUpdate = window.confirm(`Etes vous sure de vouloir noter l'ouvrage ${ean} - ${product_name.length > 50 ? product_name.substring(0, 45).concat(" (...)") : product_name} comme indisponible?`);
      if (!confirmUpdate) {
        return; // If the user cancels, exit the function
      }

    }
    const data = {order_id: id, status: status}
    const response = await postData('/update_martelle_order', data);
    if (response) {
      setRefresh(!refresh);
        notify('Commande mise à jour')
    }
    if (error) {
      notify(error)
  }
  }

  const createShipment = async () => {
    setDirectShippingInProcess(true);
    const data = {order_id: id, global_order_id: global_order_id}
    const response = await postData('/create_direct_to_customer_martelle_shipment', data);
    if (response) {
      setRefresh(!refresh);
      notify(response.message)
    }
    setDirectShippingInProcess(false);
  }

  const handleEditClick = () => {
    onUpdateClick(id);
    openOrderUpdateForm();
  };

  const handleCommentClick = () => {
    onUpdateClick(id);
    openCommentForm();
  };

  const get_label_url = async () => {
    setDirectShippingInProcess(true);
    const data = {martelle_order_id: id}
    const response = await postData('/get_label_url', data);
    if (response) {
      window.open(response.label_url, '_blank');
      notify(response.message)
      setDirectShippingInProcess(false);
    }
    else {
      setDirectShippingInProcess(false);
    }
  }

  const get_invoice_url = async () => {
    setDirectShippingInProcess(true);
    const data = {martelle_order_id: id}
    const response = await postData('/get_label_url', data);
    if (response) {
      window.open(response.invoice_url, '_blank');
      notify(response.message)
      setDirectShippingInProcess(false);
    }
    else {
      setDirectShippingInProcess(false);
    }
  }

  // Determine if the row should be red (when is_multi is true and status is 'direct' or 'direct_to_customer_to_send')
  const shouldBeRed = is_multi && (status === 'direct' || status === 'direct_to_customer_to_send');
  
  return (
    <div className="table-row" style={shouldBeRed ? { backgroundColor: '#ffebee', borderLeft: '4px solid red' } : {}}>
      <div className="date">{order_date.split('-').reverse().join('/')}</div>
      <div className="small">{global_order_id}</div>
      {<div className="product">{is_stock && <i class="fas fa-shipping-fast"></i>} {is_external && <i className="fas fa-store"></i>} {product_name.length > 50 ? product_name.substring(0, 45).concat(" (...)") : product_name}</div>}
      {<div className="order_id">{ean}</div>}
      <div className="small" style={quantity > 1 ? { color: 'red', fontWeight: 800 } : {}}>{quantity}</div>
      <div className="medium">{supplier}</div>
      <div className="price">{price} EUR</div>
      <div className="medium">{latest_date.split('-').reverse().join('/')}</div>
      <div className="status">
        {/* Hide status for multi orders that don't show buttons */}
        {!(is_multi && (status === 'direct' || status === 'direct_to_customer_to_send') && !showButtons) && (
          <>
            {INTERNAL_STATUS[status]} {(status === 'direct' || status === 'direct_to_customer_to_send') && `(${destination_country})`}
          </>
        )}
      </div>
      <div className="medium">
        {direct_shipping_in_process && <i className="fas fa-spinner fa-spin"></i>}
        {!direct_shipping_in_process && <>
          {/* Show only multi icon and order ID for multi orders that shouldn't show buttons */}
          {is_multi && (status === 'direct' || status === 'direct_to_customer_to_send') && !showButtons && (
            <>
              <i className="fas fa-link" title="Commande Multiple"></i>
              <span style={{ marginLeft: '8px', fontSize: '0.9em', color: '#666' }}>#{global_order_id}</span>
            </>
          )}
          
          {/* Show full buttons and icons for orders that should show buttons */}
          {showButtons && (
            <>
              {(comment && comment !== '') && <i onClick={handleCommentClick} className="fas fa-comment"></i>}
              {(!comment || comment === '') && <i onClick={handleCommentClick} className="far fa-comment"></i>}
              {is_multi && <i className="fas fa-link"></i> }
              {status !== 'direct' && status !== 'direct_to_customer_to_send' && status === 'pending_cancelation' && <i onClick={() => updateStatus('en_commande')} className="fas fa-window-close"  style={{ color: 'red' }} title='Annulation Refusée'></i>}
              {status !== 'direct' && status !== 'direct_to_customer_to_send' && status === 'pending_cancelation' && <i onClick={() => updateStatus('canceled')} className="fas fa-check-square"  style={{ color: 'green' }} title='Annulation Validée'></i>}
              {status !== 'direct' && status !== 'direct_to_customer_to_send' && status !== 'pending_cancelation' && status!== 'a_envoyer' && <i onClick={() => updateStatus('unavailable')} className="fas fa-window-close"  style={{ color: 'red' }} title='Indisponible'></i>}
              {status !== 'direct' && status !== 'direct_to_customer_to_send' && status === 'a_saisir' && <i onClick={() => updateStatus('en_commande')} className="fas fa-pause-circle"  style={{ color: 'blue' }} title='En Commande'></i>}
              {status !== 'direct' && status !== 'direct_to_customer_to_send' && status !== 'pending_cancelation' && status !== 'a_envoyer' && <i onClick={() => updateStatus('a_envoyer')} className="fas fa-check-square"  style={{ color: 'green' }} title='A Envoyer'></i>}
              {status === 'direct' && <i className="fas fa-plane-departure" style={{ color: 'red' }} title='Créer Envoi' onClick={createShipment}></i>}
              {status === 'direct_to_customer_to_send' && <> <i className="fas fa-tag" onClick={get_label_url} style={{ color: 'red' }} title='Imprimer Etiquette'></i> <i className="fas fa-file-invoice" onClick={get_invoice_url} style={{ color: 'red' }} title='Imprimer facture'></i> <i onClick={() => updateStatus('sent')} className="fas fa-check" style={{ color: 'green' }} title='Confirmer Envoi'></i></>}
              {status !== 'pending_cancelation' && status !== 'a_saisir' && <i onClick ={handleEditClick} className="fas fa-edit" title='Modifier'></i>}
            </>
          )}
        </>}
      </div>
    </div>
  );
};

export default OrderLine;
